/* Saved card list, CVV pay, delete and card-on-file TDR.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";
const CryptoJS = require("crypto-js");

export default {
  methods: {

    SavedcardsAction() {
      this.saved_card_list = true;
      this.getSavedCardList();
      this.hideCard_div = false;
      this.hidecardmenu = false;
      this.hideshowpaynow = false;
      this.other_cards_display = false;
    },

    // saved-card-list methods

    input_cvv(card_number, card_name, index, cof_id) {
      this.EnableSavedCardTDR(card_number);

      this.cvv_pin.one = "";
      this.cvv_pin.saved_card_name = card_name;
      this.cvv_pin.saved_card_cof_id = cof_id;
      this.cvv_pin.card_mask_pan = card_number;
      this.selectedCvvIndex = index;
    },
    //input_cvv method end

    CheckState(id) {
      if (this.selectedCvvIndex === id && this.cvv_pin.one === "") {
        this.selectedCvvIndex = null;
      }
    },

    // Pass { silent: true } when loading after login/profile so an empty
    // card list does not hijack the PROFILE tab into the manual card form.
    getSavedCardList(opts) {
      var silent = !!(opts && opts.silent);
      this.cardList = "";
      var customer_token = this.getCookie("token");

      if (customer_token !== "") {
        const options = {
          method: "GET",
          url: this.customer_api_base_url + "show-card-info-list",
          headers: {
            Authorization: "Bearer " + customer_token,
          },
        };

        axios
          .request(options)
          .then((response) => {
            // When the response is success
            if (response.data.sp_code == "200") {
              this.cardList = response.data.card_data;
              this.isShowStaticPart = true;
            }

            // When no card data saved
            else if (response.data.sp_code == "204") {
              this.cardList = [];
              this.isShowStaticPart = false;
              if (!silent) {
                this.showCofManualCardForm();
              }
            }

            // Authentication problem
            else if (response.data.sp_code == "1064") {
              this.isShowStaticPart = false;
              if (!silent) {
                this.showCofManualCardForm();
              }
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = "Authentication Problem";
            } else {
              this.isShowStaticPart = false;
              if (!silent) {
                this.showCofManualCardForm();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    deleteCardInfo(delete_id, index) {
      this.deleteCardConfirmationDialog = true;
      this.deleteConfirmationCard = true;

      this.delete_card_id = delete_id;
      this.delete_card_ui_id = index;
    },

    DeleteCardYes() {
      var cof_id = this.delete_card_id.toString();
      var cof_list_id = this.delete_card_ui_id;

      var customer_token = this.getCookie("token");

      if (customer_token !== "") {
        const options = {
          method: "DELETE",
          url: this.customer_api_base_url + "delete-card",
          headers: {
            Authorization: "Bearer " + customer_token,
          },
          data: {
            cof_id,
          },
        };

        axios
          .request(options)
          .then((response) => {
            // When the response is success
            if (response.data.sp_code == "200") {
              this.cardList.splice(cof_list_id, 1);

              if (this.cardList.length > 0) {
                this.snackbar = true;
                this.color = "success";
                this.timeout = 2000;
                this.popup_text = response.data.message;
                this.deleteCardConfirmationDialog = false;
                this.deleteConfirmationCard = false;
              } else {
                this.show_cards(1);
              }
            } else if (response.data.sp_code == "401") {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.deleteCardConfirmationDialog = false;
              this.deleteConfirmationCard = false;
            } else if (response.data.sp_code == "424") {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.deleteCardConfirmationDialog = false;
              this.deleteConfirmationCard = false;
            } else if (response.data.sp_code == "208") {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.deleteCardConfirmationDialog = false;
              this.deleteConfirmationCard = false;
            } else if (response.data.sp_code == "104") {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.deleteCardConfirmationDialog = false;
              this.deleteConfirmationCard = false;
            }

            // Authentication problem
            else if (response.data.sp_code == "1064") {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = "Authentication Problem";
              this.deleteCardConfirmationDialog = false;
              this.deleteConfirmationCard = false;
            } else {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = "Something went wrong";
              this.deleteCardConfirmationDialog = false;
              this.deleteConfirmationCard = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    DeleteCardNo() {
      this.deleteCardConfirmationDialog = false;
      this.deleteConfirmationCard = false;
      this.delete_card_id = "";
      this.delete_card_ui_id = "";
    },

    PayFromSaveCard() {
      var CryptoJSAesJson = {
        stringify: function(cipherParams) {
          var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
          if (cipherParams.iv) j.iv = cipherParams.iv.toString();
          if (cipherParams.salt) j.s = cipherParams.salt.toString();
          return JSON.stringify(j);
        },
      };
      var key = this.$route.query.order_id;
      var cvv_cvc1 = this.cvv_pin.one;
      var cvv_cvc = CryptoJS.AES.encrypt(JSON.stringify(cvv_cvc1), key, {
        format: CryptoJSAesJson,
      }).toString();

      var orderid = this.$route.query.order_id;
      var store_id = this.store_id;
      var engine_token = this.$route.query.token;
      var card_name = this.cvv_pin.saved_card_name;
      var cof_id =
        this.cvv_pin.saved_card_cof_id != null &&
        this.cvv_pin.saved_card_cof_id !== ""
          ? this.cvv_pin.saved_card_cof_id.toString()
          : "";
      var sp_login_status = this.getCookie("token");

      if (!cof_id || !this.cvv_pin.one) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Please select a card and enter CVV";
        return;
      }

      if (sp_login_status !== "") {
        var customer_token = this.getCookie("token");
        const options = {
          method: "POST",
          url: this.customer_api_base_url + "cvv-pay",
          headers: {
            Authorization: "Bearer " + customer_token,
          },
          data: {
            cvv_cvc,
            orderid,
            store_id,
            card_name,
            cof_id,
            engine_token,
          },
        };

        axios
          .request(options)
          .then((response) => {
            // Backend may return flat JSON or a wrapped { original: ... } payload
            const payload =
              (response.data && response.data.original) || response.data || {};

            if (
              (payload.sp_code == "200" || payload.message == 1) &&
              payload.url
            ) {
              this.cvv_pin.one = "";
              this.cvv_pin.saved_card_name = "";
              this.cvv_pin.saved_card_cof_id = "";
              this.cvv_pin.card_mask_pan = "";

              window.location.href = payload.url;
            } else if (payload.sp_code == "424") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = payload.message || "Payment declined";
            } else if (payload.sp_code == "104") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = payload.message || "Payment failed";
            } else {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = payload.message || "Something went wrong";
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar = true;
            this.color = "red";
            this.timeout = 2000;
            this.popup_text = "Something went wrong";
          });
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Something wrong";
      }
    },

    // Card on File TDR start
    CheckCardOnFileTdr() {
      var isLuhnFormatOk = this.ValidateCardUsingLuhnAlgorith(
        this.editedItem.card_number
      );

      if (isLuhnFormatOk) {
        var card_number_with_spaces = this.editedItem.card_number;
        var card_number_without_space = card_number_with_spaces.replace(
          /\s/g,
          ""
        );
        var bin = Number(card_number_without_space.slice(0, 6));

        if (bin.toString().length >= 6) {
          var orderid = this.$route.query.order_id;
          var store_id = this.store_id;
          var token = this.$route.query.token;
          var isTransactionEMI = this.isTransactionEMI;

          const options = {
            method: "POST",
            url: this.base_url + "cof-get-tdr-charge",
            headers: { Authorization: "Bearer " + token },
            data: { bin, orderid, store_id, isTransactionEMI },
          };

          axios
            .request(options)
            .then((response) => {
              if (response.data.sp_code == "200") {
                this.additional_fees_amt = Number(
                  response.data.additional_amount
                ).toFixed(2);
                this.payable_amt = Number(response.data.full_amount).toFixed(
                  2
                );
                this.tdr_visibility = this.is_add_commission;
                this.tdr_visibility_pay_now_btn = 0;
                this.normal_user = 0;
                this.cof_pay_now_btn_label =
                  "Pay " +
                  Number(response.data.full_amount).toFixed(2) +
                  " BDT";
              } else {
                //disable tdr
                this.tdr_visibility = 0;
                this.tdr_visibility_pay_now_btn = 0;
                this.normal_user = 1;
                this.payable_amt = 0;
                this.cof_pay_now_btn_label =
                  "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
              }
            })
            .catch((error) => {
              this.tdr_visibility = 0;
              this.tdr_visibility_pay_now_btn = 0;
              this.normal_user = 1;
              this.payable_amt = 0;
              this.cof_pay_now_btn_label =
                "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
              console.log(error);
            });
        } else {
          this.tdr_visibility = 0;
          this.tdr_visibility_pay_now_btn = 0;
          this.normal_user = 1;
          this.payable_amt = 0;
          this.cof_pay_now_btn_label =
            "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
        }
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Invalid card number";
        this.cof_pay_now_btn_label =
          "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
      }
    },
    // Card on File TDR end

    EnableSavedCardTDR(card_number) {
      var is_tdr_enabled = this.is_add_commission;

      if (is_tdr_enabled == 1) {
        var mask_card_number = card_number;
        var bin = Number(mask_card_number.slice(0, 6));

        if (bin.toString().length >= 6) {
          var orderid = this.$route.query.order_id;
          var store_id = this.store_id;
          var token = this.$route.query.token;

          const options = {
            method: "POST",
            url: this.base_url + "cof-get-tdr-charge",
            headers: { Authorization: "Bearer " + token },
            data: { bin, orderid, store_id },
          };

          axios
            .request(options)
            .then((response) => {
              if (response.data.sp_code == "200") {
                this.additional_fees_amt = Number(
                  response.data.additional_amount
                ).toFixed(2);
                this.payable_amt = Number(response.data.full_amount).toFixed(2);
                this.tdr_visibility = this.is_add_commission;
                this.tdr_visibility_pay_now_btn = 0;
                this.normal_user = 0;
                this.saved_card_paynow_label =
                  "Pay " +
                  Number(response.data.full_amount).toFixed(2) +
                  " BDT";
              } else {
                //disable tdr
                this.tdr_visibility = 0;
                this.tdr_visibility_pay_now_btn = 0;
                this.normal_user = 1;
                this.payable_amt = 0;
                this.saved_card_paynow_label =
                  "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
              }
            })
            .catch((error) => {
              this.tdr_visibility = 0;
              this.tdr_visibility_pay_now_btn = 0;
              this.normal_user = 1;
              this.payable_amt = 0;
              this.saved_card_paynow_label =
                "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
              console.log(error);
            });
        } else {
          this.tdr_visibility = 0;
          this.tdr_visibility_pay_now_btn = 0;
          this.normal_user = 1;
          this.payable_amt = 0;
          this.saved_card_paynow_label =
            "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
        }
      } else {
        this.saved_card_paynow_label =
          "Pay " + Number(this.sp_amount).toFixed(2) + " BDT";
      }
    },
  },
};
